"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useId } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import useDeviceInfo from "@/hooks/useDeviceInfo";

// Tooltip styles - extracted to prevent re-creation on each render
const TOOLTIP_STYLES = {
  backgroundColor: "#1F2937",
  color: "white",
  padding: "6px 12px",
  fontSize: "12px",
  zIndex: 50,
  boxShadow: "0 4px 16px 0 rgba(0,0,0,0.30), 0 2px 8px 0 rgba(55,55,62,0.25)"
} as const;
interface ArtistSubmissionBadgeProps {
  readonly submissionCount: number;
  readonly onBadgeClick?: () => void;
  readonly tooltipId?: string;
}
export const ArtistSubmissionBadge: React.FC<ArtistSubmissionBadgeProps> = t0 => {
  const $ = _c(18);
  const {
    submissionCount,
    onBadgeClick,
    tooltipId: t1
  } = t0;
  const tooltipId = t1 === undefined ? "submission-badge" : t1;
  const isMobile = useIsMobileDevice();
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const id = useId();
  const uniqueTooltipId = `${tooltipId}-${id}`;
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  if (submissionCount === 0) {
    return null;
  }
  let t2;
  if ($[0] !== onBadgeClick) {
    t2 = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsTooltipOpen(false);
      onBadgeClick?.();
    };
    $[0] = onBadgeClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsTooltipOpen(true);
    t4 = () => setIsTooltipOpen(false);
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = `View ${submissionCount} art submission${submissionCount === 1 ? "" : "s"}`;
  const t6 = !isMobile && !hasTouchScreen ? uniqueTooltipId : undefined;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon icon={faPalette} className="tw-w-2.5 tw-h-2.5 tw-text-white tw-flex-shrink-0" />;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t2 || $[6] !== t5 || $[7] !== t6) {
    t8 = <button onClick={t2} onMouseEnter={t3} onMouseLeave={t4} className={"tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5\n        tw-rounded-md tw-border tw-border-solid tw-border-blue-400/40\n        tw-bg-gradient-to-br tw-from-blue-800 tw-to-blue-900\n        tw-text-blue-100/90\n        tw-shadow-[0_1px_3px_rgba(0,0,0,0.45)]\n        tw-transition-all tw-duration-200 tw-ease-out\n        desktop-hover:hover:tw-from-blue-700\n        desktop-hover:hover:tw-to-blue-800\n        desktop-hover:hover:tw-scale-[1.05]\n        focus:tw-ring-1 focus:tw-ring-blue-300/40"} aria-label={t5} aria-expanded="false" aria-haspopup="dialog" data-tooltip-id={t6}>{t7}</button>;
    $[5] = t2;
    $[6] = t5;
    $[7] = t6;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== hasTouchScreen || $[10] !== isMobile || $[11] !== isTooltipOpen || $[12] !== submissionCount || $[13] !== uniqueTooltipId) {
    t9 = !isMobile && !hasTouchScreen && <Tooltip id={uniqueTooltipId} place="top" positionStrategy="absolute" content={`View ${submissionCount} art submission${submissionCount === 1 ? "" : "s"}`} delayShow={300} opacity={1} style={TOOLTIP_STYLES} isOpen={isTooltipOpen} />;
    $[9] = hasTouchScreen;
    $[10] = isMobile;
    $[11] = isTooltipOpen;
    $[12] = submissionCount;
    $[13] = uniqueTooltipId;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};